import { useEffect } from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import { useAuth } from '../context/AuthContext';
import { useBrand } from '../context/BrandContext';
import { apiRequest } from '../config/api';

const IntercomChat = () => {
  const { isAuthenticated, user } = useAuth();
  const { brandConfig } = useBrand();

  useEffect(() => {
    if (!brandConfig.intercomAppId) return;

    const fetchIntercomJwt = async () => {
      if (isAuthenticated && user) {
        try {
          const response = await apiRequest('/auth/intercom-jwt');
          if (response.ok) {
            const data = await response.json();

            let createdAt = null;
            if (user.created_at) {
              const date = new Date(user.created_at);
              createdAt = Math.floor(date.getTime() / 1000);
            }

            Intercom({
              app_id: brandConfig.intercomAppId,
              created_at: createdAt,
              name: user.full_name || user.username,
              intercom_user_jwt: data['intercom_user_jwt'],
            });
          } else {
            console.warn('Failed to fetch Intercom JWT, proceeding without secure mode');
          }
        } catch (error) {
          console.warn('Error fetching Intercom JWT:', error);
        }
      }
    };

    fetchIntercomJwt();
  }, [isAuthenticated, user, brandConfig.intercomAppId]);

};

export default IntercomChat;